(() => {
  const norm = (s) => (s || "").toLowerCase().replace(/\s+/g, " ").trim();
  const productJsonCache = new Map();

  let scheduled = false;
  let boundVp = null;
  let vpObserver = null;
  let bodyObserver = null;

 function isBundleProductPage() {
  return !!document.querySelector(
    '.product-form[data-product-type="bundle-product"], [data-product-type="bundle-product"]'
  );
}

function findBundleRoot() {
  if (!isBundleProductPage()) return null;

  const heading = [...document.querySelectorAll("button, summary, .heading, p, span")]
    .find((el) => norm(el.textContent) === "se alle produkter i pakken");

  if (heading) {
    const accordion =
      heading.closest("details") ||
      heading.closest(".custom-accordion") ||
      heading.closest(".accordion") ||
      heading.parentElement;

    return (
      accordion?.querySelector(".bundle-products__collapse-content") ||
      accordion?.querySelector(".bundle-products") ||
      accordion
    );
  }

  return (
    document.querySelector(".bundle-products__collapse-content") ||
    document.querySelector(".bundle-products") ||
    null
  );
}

  function findAccordionWrapper() {
    const heading = [...document.querySelectorAll("button, summary, .heading, p, span")]
      .find((el) => norm(el.textContent) === "se alle produkter i pakken");

    if (heading) {
      return (
        heading.closest("details") ||
        heading.closest(".custom-accordion") ||
        heading.closest(".accordion") ||
        heading.parentElement
      );
    }

    return (
      document.querySelector(".custom-accordion") ||
      document.querySelector("details") ||
      document.querySelector(".bundle-products")?.parentElement ||
      null
    );
  }

  function parseBundleItems() {
    const root = findBundleRoot();
    if (!root) return [];

    const links = [...root.querySelectorAll("a[href*='/products/']")];
    const itemsFromLinks = links
      .map((a) => {
        const title = (a.textContent || "").trim();
        const href = a.getAttribute("href") || "";
        const m = href.match(/\/products\/([^\/?#]+)/i);
        const handle = m?.[1] || null;
        return title.length > 1 ? { title, handle } : null;
      })
      .filter(Boolean);

    if (itemsFromLinks.length) {
      const seen = new Set();
      return itemsFromLinks.filter((it) => {
        const key = `${norm(it.title)}|${it.handle || ""}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    const raw = (root.textContent || "")
      .replace(/se alle produkter i pakken/gi, "")
      .trim();

    if (!raw) return [];

    const parts = raw
      .split(/\n|•|·|;|\s\|\s/g)
      .map((s) => s.trim())
      .filter((s) => s.length > 2);

    const seen = new Set();
    return parts
      .filter((t) => {
        const key = norm(t);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .map((t) => ({ title: t, handle: null }));
  }

  function getSelectableProductTitles() {
    const titles = new Set();

    document.querySelectorAll("variant-picker .product-form__option-name").forEach((el) => {
      const txt = norm(el.textContent);
      if (txt && txt !== "inkluderet") titles.add(txt);
    });

    document.querySelectorAll(".product-sticky-form__variants .combo-box__title").forEach((el) => {
      const txt = norm(el.textContent);
      if (txt && txt !== "inkluderet") titles.add(txt);
    });

    document.querySelectorAll(
      "variant-picker select, variant-picker fieldset, .product-sticky-form__variants select"
    ).forEach((el) => {
      const txt = norm(
        el.getAttribute("aria-label") ||
          el.getAttribute("name") ||
          el
            .closest(".product-form__option-selector, .select-wrapper")
            ?.querySelector(".product-form__option-name, .combo-box__title")
            ?.textContent ||
          ""
      );

      if (txt && txt !== "inkluderet") titles.add(txt);
    });

    return titles;
  }

  function filterIncludedItems(items) {
    const selectableTitles = getSelectableProductTitles();

    return items.filter((item) => {
      const title = norm(item.title);

      if (selectableTitles.has(title)) return false;

      for (const s of selectableTitles) {
        if (s.includes(title) || title.includes(s)) return false;
      }

      return true;
    });
  }

  async function fetchProductJson(handle) {
    if (!handle) return null;
    if (productJsonCache.has(handle)) return productJsonCache.get(handle);

    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      productJsonCache.set(handle, data);
      return data;
    } catch (e) {
      console.warn("Kunne ikke hente product JSON for", handle, e);
      productJsonCache.set(handle, null);
      return null;
    }
  }

  function getAutoSelectedVariantLabelByTitle(productTitle) {
    const t = norm(productTitle);
    const selects = [
      ...document.querySelectorAll("variant-picker select, .product-sticky-form__variants select"),
    ];

    for (const sel of selects) {
      const aria = norm(sel.getAttribute("aria-label") || "");
      const name = norm(sel.getAttribute("name") || "");

      if (!(aria.includes(t) || name.includes(t))) continue;

      const opt = sel.selectedOptions?.[0] || sel.options?.[sel.selectedIndex];
      if (!opt) continue;

      const label = (opt.textContent || "").trim();
      if (!label || label.toLowerCase() === "default title") continue;

      return label;
    }

    return null;
  }

  async function getSingleAvailableVariantTitleFromProductJson(handle) {
    const data = await fetchProductJson(handle);
    if (!data || !Array.isArray(data.variants)) return null;

    const available = data.filter ? [] : null;
    const availableVariants = data.variants.filter((v) => v && v.available);

    if (availableVariants.length === 1) {
      const title = (availableVariants[0].title || "").trim();
      if (title && title.toLowerCase() !== "default title") return title;
    }

    return null;
  }

  async function findRelevantVariant(item) {
    if (!item.handle) return null;

    const data = await fetchProductJson(item.handle);
    if (!data || !Array.isArray(data.variants)) return null;

    const uiLabel = getAutoSelectedVariantLabelByTitle(item.title);
    if (uiLabel) {
      const wanted = norm(uiLabel);

      const exact = data.variants.find((v) => norm(v.title) === wanted);
      if (exact) return exact;

      const loose = data.variants.find((v) => {
        const title = norm(v.title);
        return title.includes(wanted) || wanted.includes(title);
      });
      if (loose) return loose;
    }

    const available = data.variants.filter((v) => v && v.available);
    if (available.length === 1) return available[0];
    if (available.length > 0) return available[0];

    return data.variants[0] || null;
  }

  async function formatTitleWithVariant(item) {
    const uiLabel = getAutoSelectedVariantLabelByTitle(item.title);
    if (uiLabel) return `${item.title} (${uiLabel})`;

    if (item.handle) {
      const singleVariant = await getSingleAvailableVariantTitleFromProductJson(item.handle);
      if (singleVariant) return `${item.title} (${singleVariant})`;
    }

    return item.title;
  }

  function ensureIncludedMainContainer(label = "Inkluderet") {
    let block = document.querySelector('[data-bundle-included-group="1"][data-bundle-main="1"]');

    if (!block) {
      block = document.createElement("div");
      block.className = "product-form__option-selector bundle-included-selector";
      block.setAttribute("data-bundle-included-group", "1");
      block.setAttribute("data-bundle-main", "1");

      block.innerHTML = `
        <div class="product-form__option-info">
          <span class="product-form__option-name">${label}</span>
        </div>
        <div class="bundle-included-list"></div>
      `;
    }

    const name = block.querySelector(".product-form__option-name");
    if (name) name.textContent = label;

    const accordion = findAccordionWrapper();
    const vp = document.querySelector("variant-picker");
    const parent =
      accordion?.parentElement ||
      vp?.parentElement ||
      document.querySelector(".product-form") ||
      document.body;

    if (block.parentNode !== parent) {
      parent.appendChild(block);
    }

    if (accordion && accordion.parentNode === parent) {
      parent.insertBefore(block, accordion);
    } else if (vp && vp.parentNode === parent) {
      if (vp.nextSibling) parent.insertBefore(block, vp.nextSibling);
      else parent.appendChild(block);
    }

    return block.querySelector(".bundle-included-list");
  }

  function ensureIncludedStickyContainer(label = "Inkluderet") {
    const sticky = document.querySelector(".product-sticky-form__variants");
    if (!sticky) return null;

    let wrapper = sticky.querySelector('[data-bundle-included-group="1"][data-bundle-sticky="1"]');

    if (!wrapper) {
      wrapper = document.createElement("div");
      wrapper.className = "select-wrapper";
      wrapper.dataset.selectorType = "dropdown";
      wrapper.setAttribute("data-bundle-included-group", "1");
      wrapper.setAttribute("data-bundle-sticky", "1");

      wrapper.innerHTML = `
        <div class="combo-box" style="position:relative;">
          <header class="combo-box__header">
            <p class="combo-box__title heading h6">${label}</p>
          </header>
          <div class="bundle-fixed-list"></div>
        </div>
      `;

      sticky.appendChild(wrapper);
    } else {
      const title = wrapper.querySelector(".combo-box__title");
      if (title) title.textContent = label;
    }

    return wrapper.querySelector(".bundle-fixed-list");
  }

  async function renderFixedItems(items) {
    const mainList = ensureIncludedMainContainer("Inkluderet");
    const stickyList = ensureIncludedStickyContainer("Inkluderet");

    const displayTitles = await Promise.all(items.map(formatTitleWithVariant));

    if (mainList) {
      mainList.innerHTML = "";

      if (!displayTitles.length) {
        const item = document.createElement("div");
        item.className = "bundle-included-item bundle-included-item--selected";
        item.textContent = "–";
        mainList.appendChild(item);
      } else {
        displayTitles.forEach((t) => {
          const item = document.createElement("div");
          item.className = "bundle-included-item bundle-included-item--selected";
          item.textContent = t;
          mainList.appendChild(item);
        });
      }
    }

    if (stickyList) {
      stickyList.innerHTML = "";

      if (!displayTitles.length) {
        const item = document.createElement("div");
        item.className = "bundle-fixed-value bundle-fixed-value--selected";
        item.textContent = "–";
        stickyList.appendChild(item);
      } else {
        displayTitles.forEach((t) => {
          const item = document.createElement("div");
          item.className = "bundle-fixed-value bundle-fixed-value--selected";
          item.textContent = t;
          stickyList.appendChild(item);
        });
      }
    }
  }

  function findCurrentPriceNode() {
    return (
      document.querySelector(".product-meta__price-list-container .price-list .price.price--large") ||
      document.querySelector(".product-meta__price-list-container .price-list .price") ||
      document.querySelector(".product-meta__price-list-container .price-list span") ||
      document.querySelector(".price-list .price.price--large") ||
      document.querySelector(".price-list .price") ||
      null
    );
  }

function ensureBundleCompareAtNode() {
  if (!isBundleProductPage()) return null;

  const currentPriceNode = findCurrentPriceNode();
  if (!currentPriceNode) return null;

  const priceList =
    currentPriceNode.closest(".price-list") ||
    document.querySelector(".product-meta__price-list-container .price-list");

  if (!priceList) return null;

  let el = priceList.querySelector("[data-bundle-compare-at]");
  if (!el) {
    el = document.createElement("span");
    el.setAttribute("data-bundle-compare-at", "true");
    el.className = "price price--large bundle-compare-at";
    el.style.marginLeft = "8px";
    el.style.opacity = "0.7";
    el.style.textDecoration = "line-through";
    el.style.whiteSpace = "nowrap";
  }

  if (el.parentNode !== priceList) {
    priceList.appendChild(el);
  }

  if (currentPriceNode.nextSibling !== el) {
    priceList.insertBefore(el, currentPriceNode.nextSibling);
  }

  return el;
}

  function formatMoney(cents) {
    return new Intl.NumberFormat("da-DK", {
      style: "currency",
      currency: "DKK",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format((cents || 0) / 100);
  }
  
async function renderBundleMsrp(allBundleItems) {
  if (!isBundleProductPage()) return;

  let totalCents = 0;
  let foundAny = false;

  for (const item of allBundleItems) {
    const variant = await findRelevantVariant(item);
    if (!variant) continue;

    const msrp = variant.compare_at_price || variant.price || 0;
    if (!msrp) continue;

    totalCents += msrp;
    foundAny = true;
  }

  const compareAtEl = ensureBundleCompareAtNode();
  const currentPriceNode = findCurrentPriceNode();

  if (!compareAtEl || !currentPriceNode) return;

  if (!foundAny || totalCents <= 0) {
    compareAtEl.textContent = "";
    compareAtEl.style.display = "none";
    currentPriceNode.style.color = "";
    return;
  }

  compareAtEl.textContent = formatMoney(totalCents);
  compareAtEl.style.display = "";

  // kun bundle + kun når vejl. pris faktisk vises
  currentPriceNode.style.color = "#DE2A2A";
}

async function run() {
  const includedMain = document.querySelector('[data-bundle-included-group="1"][data-bundle-main="1"]');
  const includedSticky = document.querySelector('[data-bundle-included-group="1"][data-bundle-sticky="1"]');
  const compareAt = document.querySelector("[data-bundle-compare-at]");
  const currentPriceNode = typeof findCurrentPriceNode === "function" ? findCurrentPriceNode() : null;

  if (!isBundleProductPage()) {
    if (includedMain) includedMain.remove();
    if (includedSticky) includedSticky.remove();
    if (compareAt) compareAt.remove();
    if (currentPriceNode) currentPriceNode.style.color = "";
    return;
  }

  const allBundleItems = parseBundleItems();
  if (!allBundleItems.length) {
    if (includedMain) includedMain.remove();
    if (includedSticky) includedSticky.remove();
    if (compareAt) compareAt.remove();
    if (currentPriceNode) currentPriceNode.style.color = "";
    return;
  }

  const includedItems = filterIncludedItems(allBundleItems);

  await renderFixedItems(includedItems);
  await renderBundleMsrp(allBundleItems);
}

  function scheduleRun() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(async () => {
      scheduled = false;
      try {
        await run();
      } catch (e) {
        console.error("Bundle script fejl:", e);
      }
    });
  }

  function bindToVariantPicker() {
    const vp = document.querySelector("variant-picker");
    if (!vp || vp === boundVp) return;

    if (vpObserver) vpObserver.disconnect();
    boundVp = vp;

    vp.addEventListener("change", () => {
      scheduleRun();
      setTimeout(scheduleRun, 80);
      setTimeout(scheduleRun, 250);
      setTimeout(scheduleRun, 600);
      setTimeout(scheduleRun, 1200);
    });

    vp.addEventListener("click", () => {
      setTimeout(scheduleRun, 80);
      setTimeout(scheduleRun, 250);
    });

    vpObserver = new MutationObserver(() => {
      scheduleRun();
    });

    vpObserver.observe(vp, { childList: true, subtree: true });
    scheduleRun();
  }

  function boot() {
    if (!isBundleProductPage()) return;

    scheduleRun();
    bindToVariantPicker();

    if (bodyObserver) bodyObserver.disconnect();
    bodyObserver = new MutationObserver(() => {
      bindToVariantPicker();
      scheduleRun();
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });

    setTimeout(scheduleRun, 250);
    setTimeout(scheduleRun, 700);
    setTimeout(scheduleRun, 1500);
    setTimeout(scheduleRun, 2500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();